module.exports = __webpack_public_path__ + "img/pic_400004.0da93a46.jpg";